<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="page07">
<p class="dedicationText"><em class="italic">To the one in six boys and one in four girls</em></p>
</a><a id="page08">
</a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416995050_ded01.vue?79d96ca4